import { configureStore } from '@reduxjs/toolkit'

/* Reducers */
import language from './language'

const store = configureStore({
    reducer: { language }
})

export { store }